module.exports = __webpack_public_path__ + "media/images/child-abuse-victimization-graph-376fb9ea823d9cdff6811f1fcff62e19.png";